import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardDropAuthor } from "./WaveLeaderboardDropAuthor";
interface WaveLeaderboardDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showAvatar?: boolean | undefined;
}
export const WaveLeaderboardDropHeader: React.FC<WaveLeaderboardDropHeaderProps> = t0 => {
  const $ = _c(3);
  const {
    drop,
    showAvatar: t1
  } = t0;
  const showAvatar = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== drop || $[1] !== showAvatar) {
    t2 = <div className="tw-flex tw-min-w-0 tw-items-center"><WaveLeaderboardDropAuthor drop={drop} showAvatar={showAvatar} /></div>;
    $[0] = drop;
    $[1] = showAvatar;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};